export function updateHtmlLanguage(language) {
    const htmlElements = document.getElementsByTagName('html');
    const htmlArr: Array<Element> = Array.from(htmlElements);
    for (const htmlTag of htmlArr) {
        htmlTag.setAttribute('lang', language);
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/accessibility/accessibility.ts